import { CompensationFormat } from '/@/modules/liability/enums/CompensationFormat';
import { CompensationType } from '/@/modules/liability/enums/CompensationType';

export class CompensationLiabilityMeta {
  /**
   * @var {string}
   */
  type;

  /**
   * @var {float}
   */
  hourlyRate;

  /**
   * @var {float}
   */
  numberOfHours;

  /**
   * @var {string}
   */
  format;

  /**
   * @var {string}
   */
  recurrenceStartDate;

  /**
   * @var {float}
   */
  recurrenceShare;

  constructor(model = {}) {
    this.type = model.type;
    this.hourlyRate = model.hourlyRate;
    this.numberOfHours = model.numberOfHours;
    this.format = model.format;
    this.recurrenceStartDate = model.recurrenceStartDate;
    this.recurrenceShare = model.recurrenceShare ?? 0.4;
  }

  /**
   * @returns {boolean}
   */
  get isFixedFormat() {
    return this.format === CompensationFormat.FIXED.key;
  }

  /**
   * @returns {boolean}
   */
  get isPercentFormat() {
    return this.format === CompensationFormat.PERCENT.key;
  }

  /**
   * @returns {boolean}
   */
  get isRecurringType() {
    return this.type === CompensationType.RECURRING.key;
  }

  /**
   * @returns {boolean}
   */
  get isOneTimeType() {
    return this.type === CompensationType.ONE_TIME.key;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return CompensationType.getByKey(this.type).title;
  }
}
